import { useMemo } from 'react';
import pick from 'lodash/pick';

import {
  makeLocalFieldsValidation,
  useFormState,
  useFormValidation,
} from '../../../hocs/useFormWithValidation';
import useFields from './useFields';

export function useAuthPersonalInfoForm(profile, errors, options) {
  const { initialState, initialFields, validationFields } = useFields(options);

  const { formState, handleFormChange } = useFormState({
    ...initialState,
    ...pick(profile, initialFields),
  });

  const { validateErrors, clearErrors } = useFormValidation(errors);

  const validateRequiredFields = useMemo(() => {
    return makeLocalFieldsValidation(validationFields);
  }, []);

  const isValid = validateRequiredFields(formState);

  return {
    formState,
    handleFormChange,
    validateErrors,
    clearErrors,
    isValid,
  };
}



// WEBPACK FOOTER //
// ./src/components/Auth/utils/useAuthPersonalInfoState.js